import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { Heading, PositiveNumberField } from '@superops/ui-design-system';

import { ServiceCatalogFormContext } from '../index';
import { ServiceCatalogItem } from '../../types';
import { ServiceItemsDropdown, SelectedServiceItems } from '../../Components';
import { Column, CurrencyField } from '@nile/components';

function ServiceBundleTypeItem({
  removeBundledItem,
  handleBundledItems,
  selectedCatalogItem,
  handlePropertyChange,
  disableServiceCatalogItemCostAndPrice
}: {
  handleBundledItems: (item) => void;
  removeBundledItem: (itemId) => void;
  selectedCatalogItem: ServiceCatalogItem;
  handlePropertyChange: (key, val) => void;
  disableServiceCatalogItemCostAndPrice: boolean;
}) {
  const { errors, validate, currencyValue, currencyCode } = useContext(
    ServiceCatalogFormContext
  );

  function handleHourlyRateChange(value) {
    handlePropertyChange('sellingPrice', {
      ...selectedCatalogItem?.sellingPrice,
      model: 'PER_UNIT',
      details: [
        {
          ...selectedCatalogItem?.sellingPrice?.details[0],
          value: value || null
        }
      ]
    });
  }

  return (
    <div className="grid g20">
      <CurrencyField
        type="number"
        label={
          <>
            <FormattedMessage id="admin.serviceCatalog.offeringType.quantity.price" />
            :
          </>
        }
        size="small"
        placeholder="0"
        // suffix={`${currencyValue}${currencyCode}`}
        value={selectedCatalogItem?.sellingPrice?.details?.[0]?.value || ''}
        autoComplete="off"
        onChange={handleHourlyRateChange}
        error={
          (errors?.['sellingPrice']?.[0] ||
            errors?.['sellingPrice.details']?.[0]) && (
            <FormattedMessage id="Price cannot be empty" />
          )
        }
        disabled={disableServiceCatalogItemCostAndPrice}
        showCurrency
        currencyInPrefix={false}
      />
      <Column gap={10} className="mt-20">
        <Heading element="h5">
          <FormattedMessage id="Usage" />
        </Heading>
        <div className="fx actr g5">
          <FormattedMessage id="admin.serviceCatalog.offeringType.serviceBundle.included.items" />
          <ServiceItemsDropdown
            onChange={handleBundledItems}
            offerItemType="SERVICE_BUNDLE"
            filterServiceItems={
              selectedCatalogItem?.serviceTypeItem?.bundledItems || []
            }
            isDisabled={disableServiceCatalogItemCostAndPrice}
          />
        </div>
        <SelectedServiceItems
          selectedServiceItems={
            selectedCatalogItem?.serviceTypeItem?.bundledItems
          }
          onDeleteHandler={removeBundledItem}
          isDisabled={disableServiceCatalogItemCostAndPrice}
        />
      </Column>
    </div>
  );
}

export default ServiceBundleTypeItem;
